import { render, staticRenderFns } from "./EditCards.vue?vue&type=template&id=dffe83da&scoped=true&"
import script from "./EditCards.vue?vue&type=script&lang=js&"
export * from "./EditCards.vue?vue&type=script&lang=js&"
import style0 from "./EditCards.vue?vue&type=style&index=0&id=dffe83da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffe83da",
  null
  
)

export default component.exports